import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateStateData } from "../../../../Store/actions";
import { findStoreIds } from "../../../../api_calls/utils";
import MultiSelect from "../../../../components/commonComponents/Selectors/MultiSelect";
import { checkUserRole } from "../../../../api_calls/userManagement";

const CampaignStoresFilter = ({ reduxKeywordToSaveValue, filterParamRegionName, filterParamNielsenRegionCode, regionFilterEnabled, nielsenRegionFilterEnabled }) => {
    const storeDetails = useSelector((state) => state.userSelections);
    const [changesMade, setChangesMade] = React.useState(false);
    const [storesSelection, setStoreSelection] = React.useState([]);
    const [storeNameOptionSelected, setStoreNameOptionsSelected] = React.useState([]);
    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [defaultValuesLoaded, setDefaultValuesLoaded] = React.useState(false);
    const [storeList, setStoreList] = React.useState([]);
    const userRole = storeDetails?.brand_report_view === true ? { user_role: "Brand" } : checkUserRole();
    const dispatchAction = useDispatch();

    // to filter stores (if region or nielsen region filter is applied)
    const filterStoreOptions = () => {
        const regionsSelected = typeof storeDetails[reduxKeywordToSaveValue] !== "undefined" && typeof storeDetails[reduxKeywordToSaveValue][filterParamRegionName] !== "undefined" ? storeDetails[reduxKeywordToSaveValue][filterParamRegionName] : [];

        const nielsenRegionsSelected = typeof storeDetails[reduxKeywordToSaveValue] !== "undefined" && typeof storeDetails[reduxKeywordToSaveValue][filterParamNielsenRegionCode] !== "undefined" ? storeDetails[reduxKeywordToSaveValue][filterParamNielsenRegionCode] : [];

        let campaignStores = typeof storeDetails.campaign_detail !== "undefined" && storeDetails.campaign_detail.campaign_stores?.length > 0
            ? [...storeDetails.campaign_detail.campaign_stores].sort()
            : [];

        if (userRole.user_role === "Brand") {
            // check brand filter object to fetch stores for brand (selected by retailer)
            campaignStores = storeDetails?.brand_filters?.impression_filter?.stores
                ? [...storeDetails.brand_filters.impression_filter.stores].sort()
                : [];
        }

        return campaignStores;

        // none of the region filter selected, so the campaign stores will be returned
        // if (regionFilterEnabled === false && nielsenRegionFilterEnabled === false) {
        //     return campaignStores;
        // } else {
        //     // if only region filter has selected values
        //     if (regionFilterEnabled === true && regionsSelected.length !== 0) {
        //         // filter based on region values ()
        //         let filteredStores =
        //             typeof storeDetails.stores_list !== "undefined" && storeDetails.stores_list.length !== 0 && campaignStores.length !== 0
        //                 ? storeDetails.stores_list.filter(storeOptions => {
        //                     return campaignStores.includes(storeOptions.name) && regionsSelected.includes(storeOptions.region.name)
        //                 }).map(store => store.name)
        //                 : [];
        //         return filteredStores
        //     } else if (nielsenRegionFilterEnabled === true && regionFilterEnabled === false && nielsenRegionsSelected.length !== 0) {
        //         // filter based on nielsen values (only needed when regions are disabled)
        //         let filteredStores =
        //             typeof storeDetails.stores_list !== "undefined" && storeDetails.stores_list.length !== 0 && campaignStores.length !== 0
        //                 ? storeDetails.stores_list.filter(storeOptions => {
        //                     return campaignStores.includes(storeOptions.name) && nielsenRegionsSelected.includes(storeOptions.region.nielsenRegion)
        //                 }).map(store => store.name)
        //                 : [];
        //         return filteredStores;
        //     } else {
        //         return campaignStores;
        //     }
        // }

    }

    const storeOptions = React.useMemo(
        () => [...new Set(storeList)].map((n) => ({ value: n, label: n })),
        [storeList]
    );

    // to load stores on component mount (only execute once)
    React.useEffect(() => {
        let campaignStoreList = filterStoreOptions();

        setStoreList(campaignStoreList);
        setDataLoaded(true);
    }, []);

    // this will load filtered store options for dropdown (when region or nielsen regions are selected)
    React.useEffect(() => {
        // default value check to restrict any redux update when component mounts. We only need to change it when region/nielsen region changes.
        let campaignStoreList = filterStoreOptions();
        if (defaultValuesLoaded === true && campaignStoreList.length !== 0) {
            setStoreList(campaignStoreList);
            const StoreIds = findStoreIds(campaignStoreList, false);
            const nameOptionsSelected = [...new Set(campaignStoreList)].map((storeName) => {
                return { value: storeName, label: storeName };
            })
            dispatchAction(
                updateStateData({
                    [reduxKeywordToSaveValue]: {
                        ...storeDetails[reduxKeywordToSaveValue],
                        "store_ids": StoreIds,
                        "selected_store_names": nameOptionsSelected
                    },
                })
            );
        }
    }, [
        storeDetails?.[reduxKeywordToSaveValue]?.[filterParamRegionName],
        storeDetails?.[reduxKeywordToSaveValue]?.[filterParamNielsenRegionCode]
    ]);

    // this will execute on component load (also if store list changes at any time) to set selected values for store filter dropdown
    React.useEffect(() => {
        if (dataLoaded) {
            setStoreSelection(storeList);
            setStoreNameOptionsSelected(
                [...new Set(storeList)].map((storeName) => {
                    return { value: storeName, label: storeName };
                })
            );

            setDefaultValuesLoaded(true);
        }
    }, [dataLoaded, storeList]);

    return defaultValuesLoaded ? (
        <MultiSelect
            enableFullWidth={false}
            label={"Store"}
            options={storeOptions}
            defaultVal={typeof storeDetails[reduxKeywordToSaveValue] !== "undefined" && typeof storeDetails[reduxKeywordToSaveValue].selected_store_names !== "undefined" ? storeDetails[reduxKeywordToSaveValue].selected_store_names : []}
            selectionCheck={(option, value) => option.label === value.label}
            usedFor="storeFilter"
            onChangeCall={(selectedOption) => {
                let userChoices = [];
                setChangesMade(true);
                selectedOption.forEach((chosen) => {
                    if (chosen.label !== "(All)") {
                        userChoices.push(chosen.label);
                    } else {
                        userChoices.push([...new Set(storeList)]);
                    }
                });
                setStoreSelection(userChoices);
                setStoreNameOptionsSelected(selectedOption);
            }}
            onBlurCall={(e) => {
                if (storesSelection.length !== 0 && changesMade === true) {
                    const StoreIds = findStoreIds(storesSelection, false);
                    dispatchAction(
                        updateStateData({
                            [reduxKeywordToSaveValue]: {
                                ...storeDetails[reduxKeywordToSaveValue],
                                "store_ids": StoreIds,
                                "selected_store_names": storeNameOptionSelected
                            },
                        })
                    );
                    setChangesMade(false);
                }
            }}
        />
    ) : (
        <></>
    );
};

export default CampaignStoresFilter;
